import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartLine',
  props: {
    value: Object,
    text: String,
    lineName: String,
    subtext: String,
    legend: Array,
    series: Array,
    xAxis: Array
  },
  data: function data() {
    return {
      dom: null,
      option: {},
      index: 0
    };
  },
  watch: {
    series: {
      handler: function handler(newVal, oldVal) {
        if (this.dom) {
          if (newVal) {
            this.getDataInit();
          } else {
            this.getDataInit();
          }
        } else {
          this.init();
        }
      },
      deep: true
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },

    /**
     * 获取当前的选中状态
     */
    setSelectStatus: function setSelectStatus(index) {
      var legendSelect = {};

      for (var i in this.legend) {
        if (i == index) {
          legendSelect[this.legend[i]] = true;
        } else {
          legendSelect[this.legend[i]] = false;
        }
      }

      return legendSelect;
    },
    //紫外线信息
    setOption: function setOption(index) {
      var vm = this;
      var series = vm.series[0].data;
      var xaxis = vm.series[index].data[0].xaxis || [];
      console.log(series);
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = '';

            if (params[0].axisValue) {
              result = params[0].axisValue;
            } else if (params[1].axisValue) {
              result = params[1].axisValue;
            }

            for (var i in params) {
              if (i === '1') {
                var str = params[i].value ? '紫外线灯开' : '紫外线灯关';
                result += '<br/>' + str;
              } else {
                if (params[i].seriesName === vm.legend[1]) {
                  var _str = params[i].value ? '紫外线灯开' : '紫外线灯关';

                  result += '<br/>' + _str;
                } else {
                  var _str2 = params[i].value;
                  result += '<br/>' + params[i].seriesName + ':' + _str2;
                }
              }
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xaxis
        },
        yAxis: [{
          type: 'value',
          name: '强度',
          max: 15,
          min: 0,
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: series
      };
      return option;
    },
    setOption1: function setOption1(index) {
      var vm = this;
      var series = vm.series[0].data;
      var xaxis = vm.series[0].data[index].xaxis || [];
      console.log(series);
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = '';

            if (params[0].axisValue) {
              result = params[0].axisValue;
            } else if (params[1].axisValue) {
              result = params[1].axisValue;
            }

            for (var i in params) {
              if (i === '1') {
                var str = params[i].value ? '紫外线灯开' : '紫外线灯关';
                result += '<br/>' + str;
              } else {
                if (params[i].seriesName === vm.legend[1]) {
                  var _str3 = params[i].value ? '紫外线灯开' : '紫外线灯关';

                  result += '<br/>' + _str3;
                } else {
                  var _str4 = params[i].value;
                  result += '<br/>' + params[i].seriesName + ':' + _str4;
                }
              }
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xaxis
        },
        yAxis: [{
          type: 'value',
          name: '开关',
          data: ['打开', '关闭'],
          min: 0,
          max: 15,
          axisLabel: {
            formatter: function formatter(value) {
              var reuslt = [];

              if (value === 0) {
                reuslt.push('关闭');
              } else if (value == 6) {
                reuslt.push('打开');
              }

              return reuslt;
            }
          }
        }],
        series: series
      };
      return option;
    },
    getDataInit: function getDataInit() {
      var index = this.index;

      if (index === 0) {
        this.dom.setOption(this.setOption(index));
      } else if (index === 1) {
        this.dom.setOption(this.setOption1(index));
      }
    },
    init: function init() {
      var _this = this;

      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.showLoading();
      this.dom.setOption(this.setOption(0));
      this.dom.hideLoading();
      this.dom.on('legendselectchanged', function (res) {
        debugger;

        var index = _this.legend.indexOf(res.name);

        _this.index = index;

        if (index === 0) {
          _this.dom.setOption(_this.setOption(index));
        } else if (index === 1) {
          _this.dom.setOption(_this.setOption1(index));
        }
      });
      on(window, 'resize', this.resize);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};